import {ReactComponent as Icon} from"./stopwatch.svg"

type StopwatchIconProps = {
	className?: string;
};

const StopwatchIcon: React.FunctionComponent<StopwatchIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default StopwatchIcon;